export function getParentWindow() {
  let win = window;

  while (win !== window.parent) {
    win = window.parent;
  }

  return win;
}
